<template>
  <!-- 查看收款详情 -->
  <custom-dialog
    :title="title"
    width="1550px"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    class="accounts-collection-detail-dialog"
  >
    <div class="dialog-body">
      <div class="info-container">
        <div class="l">
          <custom-tab
            :list="tabData"
            v-model="tab"
          ></custom-tab>
          <collection
            v-if="tab === 1"
            :paymentOrReceivable="false"
            :registerMsg="registerMsg"
            :billList="billList"
            :tradeList="tradeList"
          ></collection>
          <bill
            v-if="tab === 2"
            :billData="billList"
          ></bill>
        </div>
        <div class="r">
          <div class="pay-info">
            <div class="title">{{ $t('fms_accounts_collection_detail_dialog.shou_kuan_xiang_qing') }}</div>
            <div class="order-code">
              <div class="label">{{ $t('fms_accounts_collection_detail_dialog.ding_dan_bian_hao') }}:</div>
              <div class="value">{{getPaymentCode(registerMsg)}}</div>
            </div>
            <div class="order-code">
              <div class="label">{{ $t('fms_accounts_collection_detail_dialog.fu_kuan_fang') }}:</div>
              <div class="value">{{payableOrgName}}</div>
            </div>
            <div class="group-list">
              <div class="group">
                <div class="amount">
                  <div class="should-pay"><span class="bold">{{ $t('fms_accounts_collection_detail_dialog.shi_fu_he_ji') }}：</span>￥{{actualPayAmount}}</div>
                  <div class="details">
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_collection_detail_dialog.zu_lin_yu_e') }}</div>
                      <div class="val">￥{{expectUseRest}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_collection_detail_dialog.dui_gong_zhuan_zhang') }}</div>
                      <div class="val">￥{{publicAmount}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_collection_detail_dialog.xian_jin_zhi_fu') }}</div>
                      <div class="val">￥{{cashAmount}}</div>
                    </div>
                  </div>
                  <div class="should-pay expect-rest"><span class="bold">{{ $t('fms_accounts_collection_detail_dialog.ying_shou_he_ji') }}：</span>￥{{payableTotal}}</div>
                  <div
                    class="should-pay"
                    v-if="thisRest"
                  ><span class="bold">{{ $t('fms_accounts_collection_detail_dialog.ben_ci_jie_yu') }}：</span>￥{{thisRest}}</div>
                  <div class="should-pay mt-15">{{ $t('fms_accounts_collection_detail_dialog.fu_kuan_cao_zuo_ren') }}：{{paymentConfirmUser || '-'}}</div>
                  <div class="should-pay">{{ $t('fms_accounts_collection_detail_dialog.fkczsj') }}：{{paymentConfirmTime || '-'}}</div>
                </div>
              </div>
              <div class="group">
                <div class="amount">
                  <div class="should-pay"><span class="bold">{{ $t('fms_accounts_collection_detail_dialog.yqrsk') }}：</span>￥{{total}}</div>
                  <div class="should-pay"><span class="bold">{{ $t('fms_accounts_collection_detail_dialog.yi_que_ren_shou_kuan') }}：</span>￥{{confirmTotal}}</div>
                  <div class="should-pay mt-15">{{ $t('fms_accounts_collection_detail_dialog.skczr') }}：{{receiveConfirmUser || '-' }}</div>
                  <div class="should-pay">{{ $t('fms_accounts_collection_detail_dialog.cao_zuo_shi_jian') }}：{{$momentLocal(receiveConfirmTime) || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button
        @click="onCancel"
        type="primary"
      >{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import commonDialogMixin from './dialogMixin';
import mixins from './mixins';
import collection from './accounts_collection_detail_collection';
import bill from './accounts_collection_detail_bill';

export default {
  name: '',
  mixins: [dialogMixins, commonDialogMixin, mixins],
  components: {
    collection,
    bill
  },
  props: {
    // model: {
    //   data: {
    //     // 选中的rows
    //     // billData: []
    //   }
    // }
    // false-收款  true-付款
    // paymentOrReceivable: {
    //   type: Boolean,
    //   default: false
    // },
  },
  data() {
    return {
      name: 'accountsCollectionDetailDialog',
      isLockBill: false,
      registerMsg: {
        balance: '',
        deposit: '',
        billPaymentCode: '',
      },
      // 应付款账单信息
      billList: [],
      // 付款信息
      tradeList: [],
      userType: [],
      firstOrderItem: {},
      payableOrgName: '',
      useRest: false,
      tab: 1
    };
  },
  computed: {
    // 本次结余 实付金额-应付金额，若本次结余为0时不显示此行）
    thisRest() {
      const actualPayAmount = this.actualPayAmount || 0;
      const payableTotal = this.payableTotal || 0;
      return Math.max(actualPayAmount - payableTotal, 0);
    },
    // 操作人
    receiveConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.receiveConfirmUser;
    },
    // 操作时间
    receiveConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.receiveConfirmTime;
    },
    title() {
      return this.model.title || this.$t('fms_accounts_collection_detail_dialog.shou_kuan_xiang_qing');
    },
    tabData() {
      return [
        {
          name: this.$t('fms_accounts_collection_detail_dialog.shou_kuan_xin_xi'),
          value: 1
        },
        {
          name: this.$t('fms_accounts_collection_detail_dialog.zdhxxx'),
          value: 2
        }
      ];
    },
    // 操作人: paymentConfirmUser
    paymentConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.paymentConfirmUser;
    },
    // 操作时间：paymentConfirmTime
    paymentConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return this.$momentLocal(billPayment.paymentConfirmTime);
    },
    // 支付金额总和
    total() {
      const key = 'totalAmount';
      const list = this.tradeList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    // 实付金额
    actualPayAmount() {
      const expectUseRest = this.expectUseRest || 0;
      const total = this.total || 0;
      return expectUseRest + total;
    },
    payableTotal() {
      return this.billList.reduce((total, item) => {
        const { paymentAmount = 0 } = item;
        const sum = paymentAmount;
        return sum + total;
      }, 0);
    },
    // 已确认收款
    confirmTotal() {
      const key = 'totalAmount';
      const list = this.tradeList.filter(item => item.sellerTradeCode);
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    accountPayableAuth() {
      const ret = ['del', 'addPayableOrder', 'copy'];
      if (this.billList && this.billList.length) {
        const firstItem = this.billList[0];
        if (firstItem.isLockBill) {
          return ['copy'];
        }
      }
      return ret;
    },
    accountPayableTips() {
      const item = this.firstOrderItem;
      // 首期添加提示显示
      if (item && item.termNum === 1) {
        return this.$t('fms_accounts_collection_detail_dialog.sqxtszfhtddsbdsqkyyj');
      }
      return undefined;
    },
    balance() {
      // return this.registerMsg.balance;
      return this.getTradeBalance(this.registerMsg);
    },
    // 预计使用余额
    expectUseRest() {
      // const accountTotal = this.payableTotal || 0;
      // // 是否使用余额
      // const useRest = this.useRest;
      // // 现有余额
      // const balance = this.balance || 0;
      // if (!useRest) {
      //   return 0;
      // } else {
      //   if (balance >= accountTotal) {
      //     return accountTotal;
      //   } else {
      //     return balance;
      //   }
      // }
      const payableTotal = this.payableTotal || 0;
      const tradeTotal = this.total || 0;
      const balance = this.useRest ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },
    // 对公转账
    publicAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 现金支付
    cashAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {

    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },

    // 去除传入的billData中的押金字段
    initBillList(list) {
      const ret = list.map((item) => {
        const obj = {
          ...item
        };
        obj.depositFee = 0;
        return obj;
      });
      return ret;
    },
    getPageInfo() {
      const firstItem = this.billList[0];
      const url = this.getPaymentInfoReqUrl(firstItem);
      return this.$getJSON(url).then((res) => {
        const data = res.data;
        if (data && data.billPayment) {
          this.isLockBill = data.billPayment.isLockBill;
          this.payableOrgName = data.billPayment.payableOrgName;
        }
        this.registerMsg = data;
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = this.registerMsg.deposit || 0;
        if (data.orderViewList && data.orderViewList.length) {
          this.billList = this.formatRefundBill(data.orderViewList);
        }
        if (data.tradeBoList && data.tradeBoList.length) {
          this.tradeList = [...data.tradeBoList];
          data.tradeBoList.forEach((item, index) => {
            item.attachs = [];
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              this.$set(data.tradeBoList[index], 'attachs', this.formatAttachs(imgRes.data));
            });
          });
        }
        if (data.billPayment && data.billPayment.isUseBalance) {
          this.useRest = true;
        }
      });
    },
  },
  created() { },
  mounted() {
    this.getDicMap('payment_class');
    this.billList = this.formatRefundBill(this.initBillList(this.model.data.billData));
    this.firstOrderItem = this.billList[0];
    this.getPageInfo();
  },
};
</script>

<style lang="scss">
.accounts-collection-detail-dialog {
  .mt-15 {
    margin-top: 15px;
  }
  .bold {
    font-weight: bold;
  }
  .expect-rest {
    margin-top: 24px;
  }
  .info-container {
    display: flex;
    .l {
      flex: 1;
      padding-right: 20px;
      overflow: hidden;
    }

    .r {
      width: 300px;

      .pay-info {
        .item {
          overflow: hidden;
          &:nth-child(n + 2) {
            margin-top: 4px;
          }
          .key {
            float: left;
            font-size: 12px;
            color: #4d4d4d;
            line-height: 18px;
          }
          .val {
            overflow: hidden;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 18px;
            padding-left: 16px;
            white-space: normal;
          }
        }
      }

      .pay-info {
        background: #fff;
        padding: 10px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid whitesmoke;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 30px;
          font-size: 14px;
          margin-bottom: 10px;
          font-weight: bold;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          overflow: hidden;

          .label {
            float: left;
          }
          .value {
            overflow: hidden;
            padding-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          // &:last-child {
          //   border-bottom: 1px solid rgba(245, 245, 245, 1);
          // }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 24px;
            color: #4d4d4d;
            font-size: 14px;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            padding: 16px;
            margin-top: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            line-height: 24px;
            font-size: 14px;
            margin-top: 20px;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
